/* @flow */
import React from 'react';
import Activity from 'entities/Activity';
import ActivityListCardItem from 'payments/components/ActivityListCardItem.jsx';

import './styles/ActivityList.scss';

type Props = {
  activities: Activity[],
};

class ActivityList extends React.Component {
  props: Props;

  render() {
    const { activities } = this.props;

    // next upcoming activity on top of list
    // $FlowFixMe
    activities.sort((a, b) => a.getStartAt() - b.getStartAt());

    return (
      <div className="ActivityList">
        {activities.map(activity =>
          <div key={activity.id} className="ActivityList-item">
            <ActivityListCardItem activity={activity} />
          </div>
        )}
      </div>
    );
  }
}

export default ActivityList;



// WEBPACK FOOTER //
// ./src/payments/components/ActivityList.jsx